<template>
  <PageWrapper :isLoading="isLoading">
    <template #title> کلاس های ساخته شده‌ی من </template>
    <CustomTable
      v-if="masterGroupClassList"
      ref="masterGroupClassList"
      :pageNumber="masterGroupClassFilters.pageNumber"
      :count="masterGroupClassFilters.count"
      :totalCount="totalCount"
      :tableColumns="tableColumns"
      :tableItems="masterGroupClassList"
      :cellDetailsColSpan="12"
      @changePage="changePage"
    >
      <template #actions="data">
        <BButton
          size="sm"
          variant="success"
          @click="renderRowDetails(data.index)"
        >
          مشاهده جزئیات
        </BButton>
      </template>
      <template #cellDetails="data">
        <MasterCreatedGroupClassDetails
          :classMaxCapacity="data.item.maxUserCapacity"
          :classDetailsList="data.item.masterGroupClasses"
          @refetch="refetch"
        >
        </MasterCreatedGroupClassDetails>
      </template>
    </CustomTable>
  </PageWrapper>
</template>

<script>
export default {
  emits: ["refetch"],
  mounted() {
    this.getAllMasterCreatedClasses();
  },
  data() {
    return {
      isLoading: false,
      masterGroupClassList: null,
      totalCount: null,
      masterGroupClassFilters: {
        masterId: null,
        pageNumber: 1,
        count: 10,
      },
      tableColumns: [
        {
          key: "groupClassId",
          label: "شناسه",
        },
        {
          key: "name",
          label: "عنوان کلاس",
        },
        {
          key: "duration",
          label: "حداقل زمان کلاس",
          formatter: (value) => `${value} دقیقه`,
        },
        {
          key: "minUserCapacity",
          label: "حداقل تعداد شرکت کننده ها",
          formatter: (value) => `${value} نفر`,
        },
        {
          key: "maxUserCapacity",
          label: "حداکثر تعداد شرکت کننده ها",
          formatter: (value) => `${value} نفر`,
        },
        {
          key: "masterBasePrice",
          label: "قیمت پایه استاد",
          formatter: (value, _, item) =>
            `${Intl.NumberFormat("en-US").format(value)} تومان (به ازای هر${
              item.duration
            } دقیقه)`,
        },
        {
          key: "actions",
          label: "عملیات",
        },
      ],
    };
  },
  methods: {
    refetch() {
      this.$emit("refetch");
      this.getAllMasterCreatedClasses();
    },
    renderRowDetails(index) {
      if (this.$refs.masterGroupClassList) {
        this.$refs.masterGroupClassList.showRowDetails(index);
      }
    },
    changePage(pageNumber) {
      this.masterGroupClassFilters.pageNumber = pageNumber;
      this.getAllMasterCreatedClasses();
    },
    async getAllMasterCreatedClasses() {
      try {
        this.masterGroupClassFilters.masterId = getUserData().user.userId;
        this.isLoading = true;
        const _this = this;
        const getMasterUpdatedGroupClasses = new GetMasterUpdatedGroupClasses(
          _this
        );
        getMasterUpdatedGroupClasses.setRequestParam(
          _this.masterGroupClassFilters
        );
        await getMasterUpdatedGroupClasses.fetch((res) => {
          if (res.isSuccess) {
            _this.masterGroupClassList = res.data.data;
            _this.totalCount = res.data.total;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    PageWrapper,
    CustomTable,
    MasterCreatedGroupClassDetails,
    BButton,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import MasterCreatedGroupClassDetails from "@/views/components/GroupClass/MasterGroupClass/MasterCreatedGroupClassDetails.vue";
import { BButton } from "bootstrap-vue";
import { getUserData } from "@/auth/utils";
import { GetMasterUpdatedGroupClasses } from "@/libs/Api/GroupClass";
</script>
